export enum FichaCadastroHomeFaseIdEnum {
  ANALISE = 1,
  APROVADAS = 2,
  PAGAMENTOS = 3,
  RECUSADAS = 4,
  CONTRATOS_CANCELADOS = 5,
}
